import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import AuthPage from './pages/AuthPage'
import ProfilePage from './pages/ProfilePage'
import HomePage from './pages/HomePage'
import { setupPWA } from './utils/pwa'
import './styles/app.css'

function App() {
  useEffect(() => {
    // Initialiser la PWA au démarrage
    setupPWA()
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('userEmail')
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={<AuthPage />} 
        />
        <Route 
          path="/profile" 
          element={<ProfilePage onLogout={handleLogout} />} 
        />
        <Route 
          path="/home" 
          element={<HomePage onLogout={handleLogout} />} 
        />
      </Routes>
    </Router>
  )
}

export default App
